import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logoutDriver } from '../features/driver/driverAuthSlice';
import { FaTrash, FaSignOutAlt, FaHome } from 'react-icons/fa';

const ClearStorage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const clearAllStorage = () => {
    // Clear localStorage
    localStorage.clear();
    
    // Clear sessionStorage  
    sessionStorage.clear();
    
    // Dispatch logout action to clear Redux state
    dispatch(logoutDriver());
    
    alert('All storage cleared successfully!');
    navigate('/');
  };

  const clearDriverAuth = () => {
    // Clear only driver-related storage
    localStorage.removeItem('driver');
    localStorage.removeItem('driverToken');
    
    // Dispatch logout action
    dispatch(logoutDriver());
    
    alert('Driver authentication cleared!');
    navigate('/driver/login');
  };

  const clearUserAuth = () => {
    // Clear user-related storage
    localStorage.removeItem('user');
    localStorage.removeItem('userToken');
    
    alert('User authentication cleared!');
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full space-y-6 bg-white p-8 rounded-lg shadow-md">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Clear Storage</h2>
          <p className="text-gray-600">Clear authentication data and local storage</p>
        </div>

        <div className="space-y-4">
          <button
            onClick={clearDriverAuth}
            className="w-full flex items-center justify-center py-3 px-4 border border-orange-300 text-orange-600 rounded-md hover:bg-orange-50 transition-colors"
          >
            <FaSignOutAlt className="mr-2" />
            Clear Driver Login
          </button>

          <button
            onClick={clearUserAuth}
            className="w-full flex items-center justify-center py-3 px-4 border border-blue-300 text-blue-600 rounded-md hover:bg-blue-50 transition-colors"
          >
            <FaSignOutAlt className="mr-2" />
            Clear User Login
          </button>

          <button
            onClick={clearAllStorage}
            className="w-full flex items-center justify-center py-3 px-4 border border-red-300 text-red-600 rounded-md hover:bg-red-50 transition-colors"
          >
            <FaTrash className="mr-2" />
            Clear All Storage
          </button>

          <button
            onClick={() => navigate('/')}
            className="w-full flex items-center justify-center py-3 px-4 bg-primary text-white rounded-md hover:bg-primary-dark transition-colors"
          >
            <FaHome className="mr-2" />
            Go to Home
          </button>
        </div>

        <div className="mt-6 p-4 bg-blue-50 rounded-md">
          <h3 className="font-medium text-blue-800 mb-2">What does this do?</h3>
          <ul className="text-sm text-blue-700 space-y-1">
            <li>• Clear Driver Login: Logs out driver and clears driver authentication</li>
            <li>• Clear User Login: Logs out regular user and clears user authentication</li>
            <li>• Clear All Storage: Removes all saved data and resets the app completely</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ClearStorage;
